import { updater } from "../../utils/updater.js";

/**
 * Inputs API factory.
 *
 */
export function inputsFactory({ state, setState }) {
  // shorthand for setState(produce(draft => {...}))
  const updateState = updater(setState);

  // reset all fields from a specific form
  const ResetFieldsInUse = (fields) => {
    Object.keys(fields).forEach((field) => {
      updateState((draft) => {
        draft.fieldsInUse[fields[field].fieldKey] = "";
      });
    });
  };

  // reset all fields in the whole context
  const ResetAllFieldsInUse = () => {
    updateState((draft) => {
      draft.fieldsInUse = {};
    });
  };

  //save value to input context
  const setFieldValue = (field, value) => {
    updateState((draft) => {
      draft.fieldsInUse[field] = value;
    });
  };
  //get last value from input context
  const getFieldValue = (field, defaultValue) => {
    if (state.fieldsInUse[field]) {
      return state.fieldsInUse[field];
    } else {
      return defaultValue;
    }
  };

  const setValue = (value) =>
    updateState((draft) => void (draft.value = value));

  const getValue = () => state.value;

  return {
    setValue,
    getValue,
    setFieldValue,
    getFieldValue,
    ResetFieldsInUse,
    ResetAllFieldsInUse,
  };
}

export default inputsFactory;
